import { render, staticRenderFns } from "./DisconnectAccount.vue?vue&type=template&id=7f812ca6&scoped=true"
import script from "./DisconnectAccount.vue?vue&type=script&lang=js"
export * from "./DisconnectAccount.vue?vue&type=script&lang=js"
import style0 from "./DisconnectAccount.vue?vue&type=style&index=0&id=7f812ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f812ca6",
  null
  
)

export default component.exports